
import OrderFeedbackSummaryRow from '@marketplace/components/account/feedback/order-feedback-summary-row.vue'
import Loader from '@marketplace/components/shared/loaders/loader.vue'
import { GET_RETAILER_ORDER_FEEDBACK_QUERY } from '@marketplace/graphql/orders.js'

export default {
    name: 'ModalOrderFeedbackDashboard',

    components: { OrderFeedbackSummaryRow, Loader },

    props: {
        data: {
            type: Array,
            default: null,
        },
    },

    computed: {
        displayedFeedback() {
            return this.viewer?.account?.orderFeedback?.data || this.data || []
        },
    },

    apollo: {
        viewer: {
            fetchPolicy: 'no-cache',
            query: GET_RETAILER_ORDER_FEEDBACK_QUERY,
            variables() {
                return {
                    first: 30,
                }
            },
        },
    },
}
